<h1 class="title-center">Integration Maintenance</h1>

@if(!dataLoading)
{
  <app-dashboard-cards>
    <app-dashboard-filter-card title="Clients">
      <ng-template>
        <app-lt-multiselect-t
          [data]="filteredClients"
          panelWidth=""
          textField="clientDisplayName"
          valueField="clientInformationId"
          placeholder="Select Clients..."
          (selectionChange)="filterMaintenance()"
          [(ngModel)]="selectedClients"></app-lt-multiselect-t>
      </ng-template>
    </app-dashboard-filter-card>

    <app-dashboard-filter-card title="Destination Endpoints">
      <ng-template>
        <app-lt-multiselect-t
          [data]="destinationEndpoints"
          panelWidth=""
          textField="displayName"
          valueField="destinationEndpointId"
          placeholder="Select Destination Endpoints..."
          (selectionChange)="filterMaintenance()"
          [(ngModel)]="selectedDestinationEndpoints"></app-lt-multiselect-t>
        </ng-template>
    </app-dashboard-filter-card>

    <app-dashboard-filter-card title="Import Types">
      <ng-template>
        <app-lt-multiselect-t
          [data]="importTypes"
          panelWidth=""
          textField="typeDescription"
          valueField="importTypeId"
          placeholder="Select Import Types..."
          (selectionChange)="filterMaintenance()"
          [(ngModel)]="selectedImportTypes"></app-lt-multiselect-t>
        </ng-template>
    </app-dashboard-filter-card>

    <app-dashboard-filter-card title="Server">
      <ng-template>
        <app-lt-multiselect-t
          [data]="servers"
          panelWidth=""
          textField="description"
          valueField="serverId"
          placeholder="Select Servers..."
          (selectionChange)="filterMaintenance()"
          [(ngModel)]="selectedServers"></app-lt-multiselect-t>
        </ng-template>
    </app-dashboard-filter-card>

    <app-dashboard-filter-card title="Integrations">
      <ng-template>
        <app-lt-multiselect-t
          [data]="filteredIntegrations"
          panelWidth=""
          textField="name"
          valueField="integrationId"
          placeholder="Select Integrations..."
          (selectionChange)="filterMaintenance()"
          [(ngModel)]="selectedIntegrations"></app-lt-multiselect-t>
      </ng-template>
    </app-dashboard-filter-card>
  </app-dashboard-cards>
}

<br />

<button matButton="elevated" class="my-2" [disabled]="!checkAccess(['LOSTalker.Admin']) || dataLoading" (click)="addMaintenance()">Add New Maintenance</button>

<br />

<app-lt-png-table #maintenanceGrid [gridSettingsInput]="maintenanceGridSettings()" [showToolbarInput]="false" (selectionChange)="selectionChangeHandler($event)"></app-lt-png-table>

<ng-template #maintenanceDialog >

  <app-edit-integration-maintenance [clients]="allClients" [destinationEndpoints]="destinationEndpoints" [importTypes]="importTypes" [servers]="servers" [integrations]="allIntegrations" [maintenance]="maintenance"
    (outputMaintenance)="updateMaintenance($event)" (deletedMaintenance)="deleteMaintenance($event)">
  </app-edit-integration-maintenance>

</ng-template>
